import {call, put, takeLatest} from 'redux-saga/effects';
import GameXpApi from '../../api/GameXpApi';
import gameXpActions from '../../actions/fortnite-game/gameXp.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';
import {NO_DATA_ERROR_CODE} from './constants';

function* getGameXp(action) {
    try {
        delete action.payload.silent;

        const {data} = yield call(GameXpApi.getData, action.payload);

        yield put(
            gameXpActions.getGameXpSuccess({
                data,
                error: data && data.activations.length ? undefined : NO_DATA_ERROR_CODE
            })
        );
    } catch (e) {
        yield put(gameXpActions.getGameXpFailed(getErrorCodeFromResponse(e), e));
    }
}

function* gameXpSaga() {
    yield takeLatest(gameXpActions.TYPES.GET_GAME_XP, getGameXp);
}

export default gameXpSaga;
